export default __webpack_public_path__ + "static/media/signature.c52a863e.png";